var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { colors, fontWeights } from '../../../defaultTheme';
import Small from '../../typography/Small';
import Inline from '../../spacing/Inline';
import Inset from '../../spacing/Inset';
const StyledTag = styled(Inset) `
  border-radius: 500px;
  color: ${({ textColor }) => textColor};
  background-color: ${({ backgroundColor }) => backgroundColor};
  display: inline-flex;
  align-items: center;
  font-weight: ${fontWeights.semiBold};
`;
const IconWrapper = styled.span `
  display: flex;
`;
const Tag = (_a) => {
    var { icon, backgroundColor, content, className, textColor = colors.black } = _a, props = __rest(_a, ["icon", "backgroundColor", "content", "className", "textColor"]);
    return (_jsxs(StyledTag, Object.assign({}, props, { backgroundColor: backgroundColor, textColor: textColor, className: className, vertical: "medium", horizontal: "xsmall" }, { children: [icon && (_jsxs(IconWrapper, Object.assign({ className: "Tag__icon-wrapper" }, { children: [icon, _jsx(Inline, { size: "small" })] }))), _jsx(Small, Object.assign({ isInline: true, className: "Tag__content", weight: "semiBold" }, { children: content }))] })));
};
export default Tag;
